//Helper functions
// import 'whatwg-fetch';
// import 'promise-polyfill/src/polyfill.js';
import {
    Modal
} from './modal.mjs';
import * as PubSub from './pubsub.mjs';
import { EntityAction } from './entityAction.mjs';
// private 

// code below is needed to support IE9+
(function () {

  if ( typeof window.Event === "function" ) return false;

  function Event ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'Event' );
    evt.initEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  window.Event = Event;

  if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
  }
})();

// end compatibility code

function getPageInfo(type) {
    let _path = window.location.pathname.split("/");
    if (_path[1] == 'weave') {
        _path.shift();
    }
    let _result = "";

    const SECTION = {
        "stock-categories": "categories",
        "branch-categories": "branchCategories",
        "stock-searches": "stockSearches",
        "import-export": "importExport"
    };

    switch (type) {
        case "action":
            _result = _path[2] ? _path[2] : false;
            break;
        case "section":
            _result = SECTION[_path[1]] ? SECTION[_path[1]] : _path[1];
            break;
        case "sectionPath":
            _result = _path[1];
            break;
        default:
            _result = false;
            break;

    }
    return _result;
}

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

// public
function notify(message, time = 2000) {
    var modal = new Modal("notification");
    var event = new Event('notify');
    modal.setModalHeader(message);
    var p = modal.open(event);
    if(time) {
        wait(time).then(()=>{
            modal.close(event);
        });
    }
    return p;
}

function notifyWithBody(header, body, time = 2000) {
    var modal = new Modal("notification");
    var event = new Event('notify');
    modal.setModalHeader(header);
    modal.setModalBody(body);
    var p = modal.open(event);
    if(time) {
        wait(time).then(()=>{
            modal.close(event);
        });
    }
    return p;
}

function notifyError(message) {
    var modal = new Modal("errorNotification");
    var event = new Event('notify');
    modal.setModalHeader(message);
    return modal.open(event);
}

function getCurrentWeave(){

    let weaveId = parseInt(Cookies.get('weaveId'), "10") ?? false;
    let weaveName = Cookies.get('weaveName') ?? false;

    return {
        "id" : weaveId,
        "name" : weaveName
    }

}

function getCurrentAuthority(){

    let authorityId = parseInt(Cookies.get('authorityId'), "10") ?? false;
    let authorityName = Cookies.get('authorityName') ?? false;

    return {
        "id" : authorityId,
        "name" : authorityName
    }

}

function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// https://flaviocopes.com/how-to-uppercase-first-letter-javascript/

function capitalize(string) {
    if (typeof string !== 'string') return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function reattachEventListener(element, event, listener) {
    var clone = element.cloneNode(true);
    element.parentNode.replaceChild(clone, element);
    clone.addEventListener(event, listener);
}

//https://github.com/daneden/animate.css#usage-with-javascript

function animateCSS(element, animationName, callback) {
    const node = document.querySelector(element);
    node.classList.add('animated', animationName);

    function handleAnimationEnd() {
        node.classList.remove('animated', animationName);
        node.removeEventListener('animationend', handleAnimationEnd);

        if (typeof callback === 'function') {
            callback();
        }
    }

    node.addEventListener('animationend', handleAnimationEnd);
}

function updateWeaveBadges() {
    var navItem = document.getElementById('weaveNavItem');

    if (!navItem) return;

    var badges = navItem.querySelectorAll('.menu-badge');
    
    badges.forEach((b)=>{
        navItem.removeChild(b);
    });
    fetch('/weave/weaves/badges').then((r)=>r.text()).then((r)=>{
        navItem.innerHTML = navItem.innerHTML + r;
    });
    updateTaskBadges();
}

function stringToHash(string) { 
                  
    var hash = 0; 
      
    if (string.length == 0) return hash; 
      
    for (var i = 0; i < string.length; i++) { 
        var char = string.charCodeAt(i); 
        hash = ((hash << 5) - hash) + char; 
        hash = hash & hash; 
    } 
      
    return hash; 
} 

function updateTaskBadges() {
    var navItem = document.getElementById('taskNavItem');
    
    if (!navItem) return;

    var badges = navItem.querySelectorAll('.menu-badge');
    badges.forEach((b)=>{
        navItem.removeChild(b);
    });
    fetch('/weave/tasks/badges').then((r)=>r.text()).then((r)=>{
        navItem.innerHTML = navItem.innerHTML + r;
    });
}

function parseUKDate (str) {
    if (!str) {
        return false;
    }
    str = str.split("/");
    return new Date(str[2], str[1] - 1, str[0]);
}

function loadHeaderBasket() {
    fetch("/basket/data/1").then(r => r.json()).then(r => {
        if (typeof BroadcastChannel != "undefined") {
            var channel = new BroadcastChannel("baskets");
            channel.postMessage(r.baskets);
        }
    });
    /* $.ajax({
        method: 'POST',
        cache: false,
        url: '/basket/header/'
    }).done(function(html) {
        $('#basket').html(html);
    }); */
}

function toggleInputError(input, message = false){
    if(message){
        var $inputHint = $(input).closest(".form-group").find(".form-input-hint");
        if($inputHint.hasClass("tooltip")){
            $inputHint.attr("data-tooltip", message);
        }else{
            $inputHint.html(message);
        }
    }
    
    $(input).addClass('shake animated');
    $(input).parents(".form-group").first().addClass("has-error");
    $(input).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(input).removeClass('shake animated');
    });
}

async function validateForm(formInputs = false) {
    var valid = true;

    if(Array.isArray(formInputs)){
        formInputs = document.querySelectorAll(formInputs.toString());  
    }
    // if nodelist
    if(NodeList.prototype.isPrototypeOf(formInputs)){
        formInputs = $(formInputs);
    }

    if(!formInputs){
        formInputs = this.form.find("[required]:visible");
    }
    
    //this.toggleFormError(valid);
    formInputs.each(function(){

        if (!$(this).hasClass("form-select") && $(this).val()) {
            $(this).parents(".form-group").removeClass("has-error");
            $(this).removeClass('shake animated');
            return;
        }

        if ($(this).hasClass("form-select") && $(this).val() != "none") {
            $(this).parents(".form-group").removeClass("has-error");
            $(this).removeClass('shake animated');
            return;
        }

        toggleInputError(this);

        valid = false;
    });

    // validate dates
    formInputs.each(function(){
        if ($(this).hasClass("form-date") && $(this).val()) {
            var date = Helper.parseUKDate($(this).val()).toUTCString();
            if (date === "") {
                toggleInputError(this, "Please enter a date in the format dd/mm/yyyy");
                valid = false;
                return;
            }
        }
    });

    /* if (this.config.checkForDuplicateNames) {
        // check for duplicate names
        var $name = this.form.find('#' + this.config.checkForDuplicateNames);
        
        var duplicate = await this.checkDuplicate($name.val(), this.id);
        
        if (duplicate.error) {
            toggleInputError($name[0], "This name is already in use");
            valid = false;
        }
    } */

    // check standard html validity
    formInputs.each(function(){
        if (!$(this)[0].checkValidity()) {
            valid = false;
            toggleInputError(this);
        }
    });

    return valid;
}

const base64 = {
    decode: s => Uint8Array.from(atob(s), c => c.charCodeAt(0)),
    encode: b => btoa(String.fromCharCode(...new Uint8Array(b)))
};


export {
    getPageInfo,
    notify,
    notifyWithBody,
    notifyError,
    capitalize,
    reattachEventListener,
    animateCSS,
    PubSub,
    stringToHash,
    updateWeaveBadges,
    updateTaskBadges,
    parseUKDate,
    getUUID,
    EntityAction,
    toggleInputError,
    validateForm,
    loadHeaderBasket,
    getCurrentAuthority,
    getCurrentWeave,
    base64
};